import { render } from "./ModalContacts.vue?vue&type=template&id=516280c2"
import script from "./ModalContacts.vue?vue&type=script&lang=js"
export * from "./ModalContacts.vue?vue&type=script&lang=js"

import "./ModalContacts.vue?vue&type=style&index=0&id=516280c2&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__